import React from 'react';
import { StorytellingSection, Section, Article, Heading, TextAccent, Link } from '../../../components';
import { Introduction, Content } from '../Work.style';
import { Logo } from './Sesame.style';
import GroupOneFeatures from './GroupOneFeatures';
import Testimonial from './Testimonial';
import GroupTwoFeatures from './GroupTwoFeatures';
import Costco from './Costco';
import MobileApp from './MobileApp';
import logo from '../../../images/logo-sesame.svg';

/**
 * Work: Sesame composition.
 */
const Sesame = () => (
  <StorytellingSection offsetKind="container" whiteSpaceSize={1}>
    <Introduction id="section:sesame">
      <Content>
        <Section>
          <Article>
            <Heading element="h2" weight={500} colorKind="neutral">
              <Logo src={logo} alt="Sesame logo" />
              <Link to="http://sesamecare.com/">Sesame</Link>, building America’s superstore for affordable top doctors
              and specialists.
            </Heading>
            <TextAccent withSpacing>
              I joined the product team at Sesame as a Senior Software Engineer, where I helped build a unique
              marketplace that makes high-quality health care more accessible and affordable. Over time, I grew into
              leading the mobile team, guiding the design and development of Sesame’s mobile platform.{' '}
            </TextAccent>
            <TextAccent withSpacing>
              Throughout my time at Sesame, I led strategic projects, optimized performance across the stack, and drove
              initiatives that significantly shaped our product and business trajectory, while also mentoring and
              growing the team. Along the way, I tackled challenges that ranged from technical infrastructure to
              high-impact partnerships, setting the stage for the next chapter of innovation at Sesame.
            </TextAccent>
            <TextAccent>
              <strong>Used technologies:</strong> NextJS, React Native, Microservices, GCP, GraphQL, TypeScript, Styled
              Components, Storybook, Jest, Playwright.
            </TextAccent>
          </Article>
        </Section>
      </Content>
    </Introduction>
    <GroupOneFeatures />
    <Costco />
    <Testimonial />
    <GroupTwoFeatures />
    <MobileApp />
  </StorytellingSection>
);

export default Sesame;
